exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-counter{font-size:13px}.good-char-count{color:var(--accent-green500)}.neutral-char-count{color:var(--neutral500)}.bad-char-count{color:var(--accent-red500)}.ic-container{align-items:flex-end}", ""]);

// exports
